export namespace Reporting {
  export const NZ_TIME_ZONE = 'Pacific/Auckland' as const;

  export interface MonthlySummaryRow {
    damagedProperty?: number;
    date: string;
    disorderRelated?: number;
    duration?: string;
    finish?: string;
    guests?: string;
    odoFinish?: number;
    odoStart?: number;
    other?: number;
    otherPatrollers?: string;
    peopleRelated?: number;
    primary?: string;
    propertyRelated?: number;
    rego?: string;
    specialService?: number;
    start?: string;
    totalKms?: number;
    vehicleRelated?: number;
  }

  export type MonthlySummary = {
    rows: MonthlySummaryRow[];
    totals: MonthlySummaryRow;
  };

  export interface YearlyPatrollerSummaryRow {
    duration: string;
    patroller: string;
    patrollerCount: number;
    primaryPatroller: number;
    totalPatrols: number;
  }

  export type YearlyPatrollerSummary = {
    rows: YearlyPatrollerSummaryRow[];
  };
}
